import { render, staticRenderFns } from "./AudienceEditor.vue?vue&type=template&id=422922eb&scoped=true&"
import script from "./AudienceEditor.vue?vue&type=script&lang=js&"
export * from "./AudienceEditor.vue?vue&type=script&lang=js&"
import style0 from "./AudienceEditor.vue?vue&type=style&index=0&id=422922eb&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "422922eb",
  null
  
)

export default component.exports